import { GUI } from 'lil-gui'
import * as THREE from 'three';
import { MeshBasicMaterial } from 'three';

export class MatManager {

    private static instance: MatManager;

    public bigLogoMat:MeshBasicMaterial;

    public Init(){

        this.bigLogoMat = new THREE.MeshBasicMaterial({color:0xff0000,side:THREE.DoubleSide});

    }


    public static getInstance(): MatManager {
        if (!MatManager.instance) {
            MatManager.instance = new MatManager();
            MatManager.instance.Init();
        }
        return MatManager.instance;
    }

}